import { oncallFetch } from "sc/backend/oncall/fetch-helper";

export default function*(email) {
  return yield oncallFetch("/api/oncall/partners/contact-details/emails/add", {
    email,
  });
}



// WEBPACK FOOTER //
// ./src/sc/backend/oncall/partners/contact-details/emails/add.js